// assets
import { IconBuildingEstate, IconUsers, IconCalendarEvent, IconBriefcase, IconSpeakerphone } from '@tabler/icons';
import ListIcon from '@mui/icons-material/List';

const icons = {
    IconBuildingEstate,
    IconUsers,
    IconCalendarEvent,
    ListIcon,
    IconBriefcase,
    IconSpeakerphone
};

const infoPages = {
    id: 'info-pages',
    title: 'SALESdb Development',
    icon: icons.IconKey,
    type: 'group',
    children: [
        {
            id: 'visit-plans-page',
            title: 'Visit Plans',
            icon: icons.IconCalendarEvent,
            type: 'item',
            url: '/visit-plans-page'
        },
        {
            id: 'visit-page',
            title: 'Visit Records',
            icon: icons.ListIcon,
            type: 'item',
            url: '/visit-page'
        },
        {
            id: 'performance-metrics-page',
            title: 'Performance Metrics',
            icon: icons.IconReportAnalytics,
            type: 'item',
            url: '/performance-metrics-page'
        },
        {
            id: 'facilities-page',
            title: 'Target Facilities',
            icon: icons.IconBuildingEstate,
            type: 'item',
            url: '/facilities-page'
        },
        {
            id: 'employees-page',
            title: 'Target Personnel',
            icon: icons.IconUsers,
            type: 'item',
            url: '/employees-page'
        },
        {
            id: 'marketing-materials-page',
            title: 'Marketing Materials',
            icon: icons.IconBriefcase,
            type: 'item',
            url: '/marketing-materials-page'
        },
        {
            id: 'marketing-actions-page',
            title: 'Marketing Actions',
            icon: icons.IconSpeakerphone,
            type: 'item',
            url: '/marketing-actions-page'
        },
    ]
};

export default infoPages;
